import ads_99qp_conf from '../assets/ads/confs/xx/99qp.banner.json'
import ads_uu_conf from '../assets/ads/confs/xx/uu.banner.json'
import yl_plaer_conf from '../assets/ads/confs/xx/yl.player.json'
import zjqp_banner_conf from '../assets/ads/confs/xx/zjqp.banner.json'
import ads_vpn_conf from '../assets/ads/confs/xx/789vpn.json'
import ads_xyg_conf from '../assets/ads/links/xyg.json'
import ads_69av_conf from '../assets/ads/links/69av.json'

import Vue from "vue";

var ads_list = {
  '69av': ads_69av_conf,
  '99qp': ads_99qp_conf,
  'uu': ads_uu_conf,
  'yl_plaer': yl_plaer_conf,
  'zjqp_banner': zjqp_banner_conf,
  'vpn': ads_vpn_conf,
  'xyg': ads_xyg_conf
}

console.log("ads_list:", ads_list);

Vue.prototype.get_ads = function (zone) {
  return ads_list[zone];
}


import ads_box from '../components/ads/box'

Vue.component('ads_box', ads_box)

import ads_box_list from '../components/ads/boxlist'

Vue.component('ads_box_list', ads_box_list)